import src from "IMAGE";
export default { src, width: 225, height: 852, blurWidth: 0, blurHeight: 0};
